<template>
  <div style="width:100%;height:100%"></div>
</template>

<script>
import pagaView from '@/pages/pageView'
export default {
  name: 'GotoAction',
  components: {},
  data() {
    return {}
  },
  created() {
    var query = this.$route.query
    let view_page = pagaView
    if (view_page[query.view_id]) {
      const page = view_page[query.view_id]
      delete query.view_id

      this.$router.push({ name: page.active_menu, query: query }, onComplete => {
        this.$store.dispatch(page.action, query)
      })
    }
  },
  mounted() {}
}
</script>
